export const PageText = {
  _1: 'Digital Health',
  _2: 'Integrate aircheckr info, alerts & recommendations to adequately inform sensitive groups. Personalised tools can help patients tackle bad air conditions better.',
  _3: 'Integrate aircheckr into your service',
  _4: 'Sensitive groups want to be guided in their daily decisions and actions in order to breathe better air.'
};

export const Categories = {
  _1: {
    title: "Health impact",
    subcategories: [
      {
        key: 0,
        subtitle: 'Need for information',
        text: 'Air pollution causes and exacerbates lung diseases like asthma and COPD and affects cardiovascular diseases. Patients need to be informed when e.g. the air quality is bad at their location. Handheld sensors measuring different pollutants however are still not mature enough and are often too expensive.'
      }
    ]
  },
  _2: {
    title: 'The aircheckr solution',
    subcategories: [
      {
        key: 0,
        subtitle: 'Personalised AQ information',
        text: 'Health organisations and specific eHealth/mHealth applications can easily access the rich aircheckr database and integrate the air quality information into their service. Personalised tools can help patients to tackle the bad air conditions better.'
      },
      {
        key: 1,
        subtitle: 'Monitoring the air',
        text: 'In a Monitoring system for respiratory diseases aircheckr constantly indicates and saves the air quality at the location of the patient. It can include features like “alarm”-function, evaluation-function (How healthy was my day?) and a link to doctors/researchers. Moreover, the system could be complemented with handheld sensor for specific measurements (e.g. inside).'
      }
    ]
  }
};

export const Quotes = [{
  key: 0,
  text: '6.5 million people in the EU fall sick as air pollution causes diseases such as strokes, asthma and bronchitis.',
  author: 'EEA, 2014'
},
{
  key: 1,
  text: 'Research shows that air pollution worsen asthma & allergy symptoms.',
  author: 'Hajime Takizawa, 2011 & Riedl MA, 2008'
}];

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/health_page.js